import React from 'react';

function AgeModal({ onConfirm }) {
  const handleDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  return (
    <div className="age-modal-overlay">
      <div className="age-modal">
        <div className="age-modal-icon">
          <span>18+</span>
        </div>
        <h2>Age Verification Required</h2>
        <p>
          This website contains information about gambling services which are only available 
          to persons aged 18 years or over.
        </p>
        <p className="age-modal-warning">
          By entering this site, you confirm that you are at least 18 years old and agree 
          to our terms of service.
        </p>
        <div className="age-modal-actions">
          <button className="btn btn-primary btn-large" onClick={onConfirm}>
            I am 18 or over – Enter
          </button>
          <button className="btn btn-secondary" onClick={handleDecline}>
            I am under 18 – Exit
          </button>
        </div>
        <p className="age-modal-help">
          Gambling can be addictive. Play responsibly.<br />
          <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer">
            GambleAware.org
          </a>
        </p>
      </div>
    </div>
  );
}

export default AgeModal;
